import settings from '../settings'
import mainStore from '../stores/mainStore'
import { HTTP } from '../types'
import { removeBlankProperty } from 'helpers/formatters/dataStructure'

const { APIKEY } = settings

export const getSessionToken = () => {
  return mainStore.sessionToken ? mainStore.sessionToken : null
}

const headers = (settings = {}) => {
  const {
    apiKey = APIKEY,
    contentType = HTTP.ContentTypes.FormUrlEncoded,
    workspace,
  } = settings
  return removeBlankProperty({
    'Content-Type': contentType,
    'x-api-key': apiKey,
    accept: HTTP.ContentTypes.JSON,
    'x-workspace': workspace,
  })
}

const baseHttpConfig = (data = {}) => ({
  validateStatus: (status) => status < 400,
  headers: headers(data),
})

const generateAuthHeaders = (accessToken, settings) => ({
  ...headers(settings),
  Authorization: `JWT ${accessToken}`,
})

export const generateConfig = (accessToken, additionalSettings) => {
  const token = additionalSettings?.accessToken || accessToken

  if (!token) {
    return {
      ...baseHttpConfig({
        contentType: additionalSettings?.contentType,
        workspace: additionalSettings?.workspace,
      }),
      ...additionalSettings,
    }
  }

  const headerSettings = {
    headers: generateAuthHeaders(token, additionalSettings),
    data: additionalSettings.data || null,
  }
  return {
    ...baseHttpConfig(),
    ...headerSettings,
    ...additionalSettings,
  }
}

export const unAuthorizedConfig = (additionalSettings) => {
  const settings = {
    headers: headers(additionalSettings),
    data: additionalSettings.data || null,
    validateStatus: (status) => status < 400,
  }

  return { ...settings, ...additionalSettings }
}

export const getAccessToken = () => mainStore.auth.token
